export default function StatisticsSection() {
  const stats = [
    { value: '20-40%', label: 'Рост выручки после системного обучения продажам', icon: 'ri-line-chart-line' },
    { value: '2-3×', label: 'Быстрее адаптация новичков при structured onboarding', icon: 'ri-speed-up-line' },
    { value: '87%', label: 'Сотрудников ценят возможность обучения выше зарплаты', icon: 'ri-heart-line' },
    { value: '70%', label: 'Знаний забывается через 2 недели без практики и сопровождения', icon: 'ri-brain-line' },
    { value: '94%', label: 'Сотрудников остались бы дольше, если бы компания инвестировала в их развитие', icon: 'ri-user-heart-line' },
    { value: '218%', label: 'ROI компаний, которые системно обучают персонал', icon: 'ri-funds-box-line' },
    { value: '40%', label: 'Снижение текучести кадров в компаниях с сильной культурой обучения', icon: 'ri-user-follow-line' },
    { value: '34%', label: 'Рост вовлечённости сотрудников при регулярном обучении', icon: 'ri-emotion-happy-line' },
  ];

  return (
    <section id="statistics" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-4">
          Корпоративное обучение в цифрах
        </h2>
        <p className="text-lg text-gray-600 text-center mb-4 max-w-3xl mx-auto">
          Компании, которые системно развивают сотрудников, быстрее адаптируются к изменениям, улучшают производительность и повышают удержание персонала
        </p>
        <p className="text-sm text-gray-500 text-center mb-14 max-w-2xl mx-auto italic">
          Современные исследования подтверждают прямую связь между инвестициями в обучение и ростом вовлечённости сотрудников, снижением текучести кадров и улучшением бизнес-показателей.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((stat, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 text-center hover:bg-teal-50 transition-colors group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${stat.icon} text-lg text-white`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-extrabold text-teal-600 mb-2">{stat.value}</div>
              <p className="text-sm text-gray-600 leading-relaxed">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}